import React,{useEffect, useState} from "react";
import { FaStar, FaMapMarkerAlt, FaCalendarAlt, FaTag, FaClock, FaUser, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import "../Styles/Common_tour_card.css";
import { useNavigate } from "react-router-dom";
import DateFormatter from "./Dateformatter";
import { CardMedia } from "@mui/material";
import SafeComponent from "./SafeComponent.jsx";
import Skeleton from "@mui/material/Skeleton";




const Common_tour_card = ({ packagedata }) => {
  console.log("key in card: ", packagedata.id);
  console.log("package data in common tour card: ", packagedata);
  const roundedRating = Math.round(packagedata?.rating * 2) / 2;
  const [total_amount,setTotal_amount]=useState(0);
  let navigate = useNavigate();
      const [adults, setAdults] = useState(1);
      const [children, setChildren] = useState(0);
      const [infants, setInfants] = useState(0);

           const [finalPrice, setFinalPrice] = useState(0);
           const [selectedPackage, setSelectedPackage] = useState("Basic");
              const [selectedHotelPrices, setSelectedHotelPrices] = useState([]);
               const [selectedTransport, setSelectedTransport] = useState(null);
                   const [hotelId, setHotelId] = useState([]);
                   const [roomId, setRoomlId] = useState([]);
                   const [transportId, setTransportId] = useState(null);
                   const [transportPrice, setTransportPrice] = useState(0);
                   const tourPriceData = packagedata;
                             const [adultExtra, setAdultExtra] = useState(tourPriceData.computed_totals?.adult_extra || 0);
          const [childExtra, setChildExtra] = useState(tourPriceData.computed_totals?.child_extra || 0);
          const [infantExtra, setInfantExtra] = useState(tourPriceData.computed_totals?.infant_extra || 0);


useEffect(() => {
    if (tourPriceData?.tour?.raw_columns?.hotel_data_raw) {
        calculateTotalPrice();
    }
}, [tourPriceData, selectedPackage, adults, children, infants]);

const calculateTotalPrice = () => {

    if (!tourPriceData?.tour?.raw_columns) return;

    const columns = tourPriceData.tour.raw_columns;
    const hotelData = columns.hotel_data_raw?.[selectedPackage];
    const transportGroup = columns.transport_data_raw?.[selectedPackage];

    const totalPeoples = 1;
    let hotelPrice = 0;
    let transportPrice = 0;

    let hotelBreakdown = [];
    let transportBreakdown = [];

    /** -----------------------------
     *  1️⃣ HOTEL PRICE CALCULATION
     * ----------------------------- */
    if (hotelData) {

        Object.values(hotelData).forEach(day => {

            const basePrice = Number(day.base_price) || 0;
            console.log("Base Price:", basePrice);
            const extraPersonPrice = Number(day.adult_extra_price) || 0;

            const rooms = 1;
           

            let perDayTotal = (rooms * basePrice)

            hotelPrice += perDayTotal;

            hotelBreakdown.push({
                hotel_id: day.hotel_id,
                room_id: day.room_id,
                hotel_name: day.hotel_name,
                rooms,
                peoples: totalPeoples,
                base_price: basePrice,
                extra_price: extraPersonPrice,
                total_for_day: perDayTotal
            });
        });
    } else {
        console.warn("No hotel data available for:", selectedPackage);
    }

    /** -----------------------------
     *  2️⃣ TRANSPORT PRICE CALCULATION
     * ----------------------------- */
    if (transportGroup) {
        Object.keys(transportGroup).forEach(dayKey => {

            const dayVehicles = transportGroup[dayKey] || [];
            console.log("Available Vehicles for Day", dayKey, ":", dayVehicles);

            const suitable = dayVehicles
                .filter(v => v.capacity >= totalPeoples)
                .sort((a, b) => a.capacity - b.capacity)[0];
console.log("Suitable Transport for Day", dayKey, ":", suitable);
            if (suitable) {
                transportPrice += Number(suitable.base_price) || 0;

                transportBreakdown.push({
                    transport_id: suitable.transport_id,
                    day: Number(dayKey),
                    capacity: suitable.capacity,
                    base_price: suitable.base_price
                });
            }
        });
    } else {
        console.warn("No transport data available for:", selectedPackage);
    }

    /** -----------------------------
     *  3️⃣ EXTRA PERSON PRICING (SAFE)
     * ----------------------------- */
    const extraPrice =
        (Number(adultExtra) * adults || 0) +
        (Number(childExtra) * children || 0) +
        (Number(infantExtra) * infants || 0);

    /** -----------------------------
     *  4️⃣ SAFE FINAL PRICE
     * ----------------------------- */
    const final =
        (Number(hotelPrice) || 0) +
        (Number(transportPrice) || 0) +
        (Number(extraPrice) || 0);

    setSelectedHotelPrices(hotelBreakdown);
    setSelectedTransport(transportBreakdown);
    setHotelId(hotelBreakdown.map(h => h.hotel_id));
    setRoomlId(hotelBreakdown.map(h => h.room_id));
    setTransportId(transportBreakdown.map(t => t.transport_id));

    console.log("Hotel Price Total:", hotelPrice);
    console.log("Transport Price Total:", transportPrice);
    console.log("Extra Price Total:", extraPrice);
    console.log("FINAL PACKAGE PRICE:", final);

    setFinalPrice(final);
};

// for Weekend and plan tour
useEffect(() => {
    if (tourPriceData?.tour?.raw_columns?.hotel_data_raw) {
        calculateTotalPrices();
    }
}, [tourPriceData, selectedPackage, adults, children, infants]);
    const calculateTotalPrices = () => {
        if (!tourPriceData?.displays) return;

        const totalPeople = adults + children;
        const hotelData =
            tourPriceData.tour?.raw_columns?.hotel_data_raw[selectedPackage];

        let total = 0;

        /** ======================================================
         *  1️⃣ HOTEL PRICE + ROOM VALIDATION + SMART TRIPLE LOGIC
         * ====================================================== */

        const getHotelPrice = () => {
            if (!hotelData) return 0;

            const requiredRooms =1
                

        

            let price = 0;
            let breakdown = [];

            Object.values(hotelData).forEach(day => {
                const base = Number(day.base_price);
                const triple = Number(day.adult_extra_price);

                let dayPrice = 0;

                /** -------------------------
                 * CASE 1 — <= 2 people
                 * ------------------------- */
                if (totalPeople <= 2) {
                    dayPrice = base;
                }

                /** -------------------------
                 * CASE 2 — Exactly 3 people
                 * ------------------------- */
                else if (totalPeople === 3) {
                    dayPrice = base + triple; // triple applied
                }

                /** -------------------------
                 * CASE 3 — More than 3 people
                 * ------------------------- */
                else {
                    const fullRooms = Math.floor(totalPeople / 2);
                    const remainder = totalPeople % 2;

                    // Default normal cost = 2 per room
                    let defaultCost = fullRooms * base;

                    // Auto triple applied only when user didn't select extra rooms


                    dayPrice = defaultCost;
                }

                /** -------------------------
                 * CASE 4 — User selects extra rooms
                 * ignore triple logic
                 * ------------------------- */
                dayPrice = requiredRooms * base;

                price += dayPrice;

                breakdown.push({
                    hotel_id: day.hotel_id,
                    room_id: day.room_id,
                    price: dayPrice
                });
            });

            console.log("Hotel Breakdown:", breakdown);

            setHotelId(breakdown.map(d => d.hotel_id));
            setRoomlId(breakdown.map(d => d.room_id));
            setSelectedHotelPrices(breakdown);

            return price;
        };

        const hotelPrice = getHotelPrice();
        if (hotelPrice === null) return;

        console.log("Hotel Price:", hotelPrice);


        /** ======================================================
         *  TRANSPORT SELECTION BASED ON TOTAL SEATS REQUIRED
         * ====================================================== */



        const transportGroup =
            tourPriceData.tour?.raw_columns?.transport_data_raw?.[selectedPackage];

        let selectedTransport = [];
        let transportIds = [];
        let transportCost = 0;

        Object.keys(transportGroup || {}).forEach(dayKey => {
            const vehicles = transportGroup[dayKey] || [];

            // filter suitable vehicle by capacity
            const validOptions = vehicles
                .filter(v => Number(v.capacity) >= totalPeople)
                .sort((a, b) => a.capacity - b.capacity);

            if (validOptions.length > 0) {
                const bestVehicle = validOptions[0];

                selectedTransport.push({
                    day: Number(dayKey),
                    ...bestVehicle,
                });

                transportIds.push(bestVehicle.transport_id);

                // ✔ per-head price per day
                transportCost += Number(bestVehicle.base_price) / Number(bestVehicle.capacity);
            }
        });

        setSelectedTransport(selectedTransport);
        setTransportId(transportIds);
        // final per-person transport price for whole trip
        // setTransportPrice(Number(transportCost.toFixed(2)));








        /** ======================================================
         *  5️⃣ EXTRAS
         * ====================================================== */

        const extraTotal =
adults * adultExtra / Number(packagedata?.tour?.counts?.total_seat)


        /** ======================================================
         *  6️⃣ FINAL TOTAL
         * ====================================================== */
  

        total = hotelPrice + Number(transportCost.toFixed(2)) + extraTotal;


        setTotal_amount(total);
    };




  return (
    <>
      {
        !packagedata ? <>loading</> :
          <div className="tour-card1" onClick={() => {
  if (packagedata.tour?.trip_type_id === 3 ) {
    navigate(`/tour/packagetour/${packagedata.tour?.id}`);
  }else if (packagedata.tour?.trip_type_id ===5) {
    navigate(`/tour/grouptour/${packagedata.tour?.id}`);
  }else if (packagedata.tour?.trip_type_id ===2) {
    navigate(`/tour/weekendtour/${packagedata.tour?.id}`);
  }
   else {
    navigate(`/tour/plantour/${packagedata.tour?.id}`);
  }
}}
>
            {/* <div className="tour-image">
        <img
          src={`${packagedata.banner}`}
          alt="Royal Rajasthan"
          style={{maxWidth:"600px"}}
        />
      </div> */}


            <CardMedia
              component="img"
              height="250"
              image={packagedata?.tour?.images?.find(img => img.is_featured)?.url}
              alt="card-img"
              sx={
                { borderRadius: "10px" }
              }
            />

            <div className="tour-content1">
              <div className="tour-rating">
                <span className="stars" style={{ display: "flex" }}>
                  {[1, 2, 3, 4, 5].map((star) => {
                    if (star <= Math.floor(roundedRating)) {
                      // Full star
                      return <FaStar key={star} style={{ color: "gold", marginRight: "2px" }} />;
                    } else if (star === Math.ceil(roundedRating) && roundedRating % 1 !== 0) {
                      // Half star
                      return <FaStarHalfAlt key={star} style={{ color: "gold", marginRight: "2px" }} />;
                    } else {
                      // Empty star
                      return <FaRegStar key={star} style={{ color: "#ccc", marginRight: "2px" }} />;
                    }
                  })}
                </span>
                <span className="rating">{packagedata?.rating || "0"}/5</span>
              </div>

              <h3 className="tour-title">{packagedata?.tour?.title}</h3>
              {/* <p className="tour_des"><SafeComponent html={packagedata?.tour?.description} /></p> */}

              <div className="tour-info">
                <p><FaMapMarkerAlt /> {packagedata?.tour?.destination?.name}</p>
                <p>
                  <FaCalendarAlt />{" "}
                  {packagedata?.tour?.dates?.booking_end_date ? (
                    <>
                      <DateFormatter dateString={packagedata?.tour?.dates?.range?.start} />{" "}
                     <span style={{color:"green"}}>...Upto</span>
                      <DateFormatter dateString={packagedata?.tour?.dates?.booking_end_date} />
                    </>
                  ) : (
                    "Choose yourself"
                  )}
                </p>

                <p><FaTag /> <span style={{ fontSize: "1.1rem", fontWeight: "600" }}> 
    ₹{
      packagedata?.tour?.trip_type_id === 2
        ? total_amount
        : packagedata?.tour?.trip_type_id === 5
        ? packagedata?.tour?.raw_columns?.mrp_group
        : packagedata?.tour?.trip_type_id === 3
        ? finalPrice
        : total_amount
    }
                </span><span>{packagedata?.tour?.trip_type_id === 3 ? `/Couple` : "/adult"}</span><span style={{color:"tomato"}}>  +taxes included</span></p>

                {/* <span style={{fontSize:"0.8rem",textDecoration:"line-through"}}>{packagedata.old_price}/-</span> */}
              </div>

              <div className="tour-footer">
                <p style={{ margin: "0px" }}><FaClock /> {packagedata?.tour?.no_of_days || "0"} days</p>
                <p style={{ margin: "0px" }}><FaUser /> {packagedata?.tour?.counts?.total_seat || "Variable"}</p>
                <button className="details-btn">
                  Details →
                </button>
              </div>
            </div>
          </div>
      }

    </>

  );
};

export default Common_tour_card;
